import { media, styled } from '@styles';
// import { css } from 'styled-components';

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 65vw;
  ${media.smallScreen`
    width:100%;
    max-width: 100vw;
  `}
`;

export const Wrapper = styled.div``;

export const Header = styled.div`
  display: flex;
  gap: 1em;
`;

export const Container = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: ${({ columns }) => `repeat(${columns < 3 ? columns : 3}, 1fr)`};
  ${media.smallScreen`
    grid-template-columns: repeat(1, 1fr);
  `}
`;

export const Card = styled.div`
  width: 100%;
  padding: 1em;
`;

export const Image = styled.div`
  width: 100%;
`;

export const Name = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Content = styled.div`
  p {
    font-size: ${(props) => props.theme.typography.smallFontSize};
    font-family: ${(props) => props.theme.typography.baseFontFamily};
    color: ${(props) => props.theme.colors.graySemi};
    margin-top: 1em;
    margin-bottom: 1em;
  }

  b {
    font-weight: 600;
  }

  strong {
    color: ${(props) => props.theme.colors.red};
  }

  i {
    font-style: italic;
  }

  & em {
    color: ${(props) => props.theme.colors.red};
  }
`;

export const Footer = styled.div`
  p {
    font-size: ${(props) => props.theme.typography.labelFontSize};
    font-family: ${(props) => props.theme.typography.baseFontFamily};
    color: ${(props) => props.theme.colors.graySemi};
  }

  b {
    font-family: ${(props) => props.theme.typography.boldFontFamily};
  }

  strong {
    font-family: ${(props) => props.theme.typography.boldFontFamily};
  }

  i {
    font-style: italic;
  }
`;
